import { VertexEvent } from './VertexEvent';
export class LeftVertexEvent extends VertexEvent {
    constructor(p) {
        super(p);
    }
}
//# sourceMappingURL=LeftVertexEvent.js.map